export const FETCH_PREVIEW_DOCUMENTS_REQUEST = 'FETCH_PREVIEW_DOCUMENTS_REQUEST'
export const FETCH_PREVIEW_DOCUMENTS_SUCCESS = 'FETCH_PREVIEW_DOCUMENTS_SUCCESS'
export const FETCH_PREVIEW_DOCUMENTS_FALUIRE = 'FETCH_PREVIEW_DOCUMENTS_FALUIRE'
